import {request} from "../../../res/rest/restRequest";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import {api} from "../../../res/rest/api";

const getOrderRequest = async (session, orderID) => {
    const req = request.model(api.MODEL.C_ORDER)
        .id(orderID)
        .expand(request.subQuery("C_BPartner_Location_ID").expand("C_Location_ID"))
        .hostURL(env.API_URL)
        .buildRequest();

    const response = await HttpClient.client.get(req, api.auth(session));
    return response.data;

}

export default getOrderRequest;